<template>
  <vx-tooltip class="w-3 h-3 rounded-full"
              :class="published ? 'bg-success' : 'border-2 border-solid border-gray-dark'"
              :enabled="isUnknownAnswer"
              position="top"
              title="Answer is published"
              :text="TOOLTIP_TEXT"
  />
</template>

<script>
const TOOLTIP_TEXT = `
  <div class="text-center w-full">
    <b>Unknown Answer</b> is always published. Your chatbot will use this reply when it does not understand the customer query.
  </div>
`

export default {
  name: 'AnswerPublishedStatus',

  props: {
    published: { type: Boolean, required: true },
    isUnknownAnswer: { type: Boolean, required: true }
  },

  data() {
    return {
      TOOLTIP_TEXT
    }
  }
}
</script>
